import React from 'react';
import {get} from 'lodash';
import className from 'classnames';

class LoadMore extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  state = {
  };

  render = () => {
    return (
      <React.Fragment>
        {!get(this.props, 'meta.isFullyLoaded') &&
          <a
            onClick={this.props.onLoadMore}
            className={className('LoadMore', {
              [`${this.props.klassName}`]: this.props.klassName,
            })}
          >
            {get(this.props, 'meta.isLoading') ? 'Loading …' : 'Load more'}
          </a>
        }
      </React.Fragment>
    );
  }
}

export default LoadMore;
